import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  {
    styledDialogTitle: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: 24,
      fontWeight: 700
    }
  },
  { name: "SetBulkUnlockCodesDialog" }
);

export default useStyles;
